import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { ApiResponse } from '@shared/models';
import { ChemicalElement, ChemicalElementDto } from '@app/store/shared/models';
import { Elements, GetElementsValue, GetElementsValueDto } from '../models';

@Service()
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getElements(value: GetElementsValue): Observable<Elements> {
        const params = new GetElementsValueDto(value).toHttpParams();

        return this.httpClient.get<ApiResponse<ChemicalElementDto[]>>('v1/admin/elements', { params }).pipe(mapDto((response) => new Elements(response)));
    }

    getElementsLookup(): Observable<ChemicalElement[]> {
        return this.httpClient
            .get<ApiResponse<ChemicalElementDto[]>>('v1/admin/elements/lookup')
            .pipe(mapDto((response) => response.data.map((dto) => new ChemicalElement(dto))));
    }
}
